
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button }from '@cmsgov/design-system';


// Constants

import { configs } from '@constants/configs/configs';
import { useNavigate } from 'react-router-dom';


const PreferencesPageControls = props => {

    const {
        actionName,
        formName,
        handleClick,
        isDashboardLocation,
        fromCAP,
        navigateToCAP
    } = props;

    const navigate = useNavigate();
    
    const handleCancel = () => {
        fromCAP ? navigateToCAP() : navigate(configs.routes.INDPORTAL);
    };

    return (
        <div className = 'tablet:grid-offset-5 txt-left'>
            <Button
                className = 'usa-button gi-button gi-button__primary'
                data-form_name = { formName }
                data-action_name = { actionName }
                onClick = { handleClick }
            >
                <FormattedMessage id='button.go_to_dashboard' />
            </Button>

            {
                (isDashboardLocation || fromCAP) &&

                <Button
                    className = 'usa-button gi-button gi-button__primary'
                    onClick = { handleCancel }
                >
                    <FormattedMessage id = 'button.cancel'/>
                </Button>
            }
        </div>
    );
};

export default PreferencesPageControls;